/* Bachelor 99 — review carousel.
   Native scroll-snap does the real work. This file only adds:
     - mouse drag on desktop (touch already scrolls natively)
     - prev / next buttons
     - arrow-key paging
   No dependencies. Safe to run more than once. */
(function () {
  'use strict';

  function step(track) {
    var card = track.querySelector('.rvcard');
    if (!card) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16) || 16;
    return card.getBoundingClientRect().width + gap;
  }

  function setup(car) {
    if (car.dataset.rvOn) return;
    car.dataset.rvOn = '1';

    var track = car.querySelector('[data-rvtrack]');
    if (!track) return;
    var prev = car.querySelector('[data-rvprev]');
    var next = car.querySelector('[data-rvnext]');

    function refresh() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    function page(dir) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: dir * step(track), behavior: reduce ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    track.addEventListener('scroll', function () {
      if (refresh.t) cancelAnimationFrame(refresh.t);
      refresh.t = requestAnimationFrame(refresh);
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); page(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); page(-1); }
    });

    /* ---- mouse drag (desktop only; touch keeps native momentum) ---- */
    var down = false, moved = false, startX = 0, startLeft = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false;
      startX = e.clientX;
      startLeft = track.scrollLeft;
      track.classList.add('drag');
    });

    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < 4) return;
      moved = true;
      track.scrollLeft = startLeft - dx;
    });

    function end() {
      if (!down) return;
      down = false;
      track.classList.remove('drag');
      if (moved) {
        /* let scroll-snap settle on the nearest card */
        var s = step(track);
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: Math.round(track.scrollLeft / s) * s, behavior: reduce ? 'auto' : 'smooth' });
      }
      setTimeout(function () { moved = false; }, 0);
      refresh();
    }

    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('pointerleave', end);

    /* a drag should never fire a click on whatever was underneath */
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    window.addEventListener('resize', refresh, { passive: true });
    refresh();
  }

  function init() {
    document.querySelectorAll('[data-rvcar]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
